function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m59.234 38.677c-.532.058-.934.511-.922 1.048v1.26c0 .579.464 1.042 1.041 1.042.573 0 1.038-.463 1.038-1.042v-1.26c.01-.63-.532-1.119-1.157-1.048z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m59.588 31.997c11.734 0 21.229 9.5 21.229 21.254 0 11.76-9.495 21.271-21.229 21.271-11.735 0-21.224-9.511-21.224-21.271 0-11.755 9.489-21.254 21.224-21.254zm0-2.084c-12.858 0-23.307 10.463-23.307 23.338 0 12.879 10.448 23.349 23.307 23.349 12.86 0 23.313-10.469 23.313-23.349 0-12.875-10.453-23.338-23.313-23.338z",
    fillRule: "evenodd",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m59.588 37.507c8.693 0 15.724 7.036 15.724 15.744 0 8.713-7.031 15.756-15.724 15.756-8.692 0-15.719-7.043-15.719-15.756 0-8.709 7.027-15.744 15.719-15.744zm0-2.079c-9.818 0-17.797 7.995-17.797 17.823 0 9.833 7.979 17.828 17.797 17.828 9.817 0 17.808-7.995 17.808-17.828 0-9.828-7.991-17.823-17.808-17.823z",
    fillRule: "evenodd",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.234 64.475c-.532.058-.934.511-.922 1.047v1.261c0 .578.464 1.042 1.041 1.042.573 0 1.038-.464 1.038-1.042v-1.261c.01-.63-.532-1.121-1.157-1.047z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.328 43.48c-.573.011-1.027.484-1.016 1.057v8.714c0 .579.464 1.041 1.041 1.041l6.131-.004c.604.042 1.109-.439 1.109-1.037 0-.604-.505-1.078-1.109-1.036l-5.093.005-.006-7.683c.011-.588-.469-1.067-1.057-1.057z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m36.396 7.382c3.233.005 6.104 2.129 7.124 5.307.136.433.538.724.986.724h5.686c.891 0 1.563.672 1.563 1.537v5.957c0 .86-.672 1.532-1.563 1.532h-27.593c-.896 0-1.574-.672-1.574-1.532v-5.957c0-.865.678-1.537 1.574-1.537h5.678c.448 0 .848-.291.983-.724 1.021-3.178 3.896-5.302 7.136-5.307zm0-2.073c-3.844.005-7.084 2.495-8.595 6.021h-14.891c-3.14 0-5.806 2.339-5.806 5.339v62.671c0 3 2.667 5.337 5.806 5.337h46.964c3.145 0 5.812-2.337 5.812-5.337v-.724c0-1.385-2.083-1.385-2.083 0v.724c0 1.76-1.589 3.266-3.729 3.266h-46.964c-2.14 0-3.729-1.506-3.729-3.266v-62.672c0-1.762 1.589-3.256 3.729-3.256h6.402c-.224.469-.364.985-.364 1.537v5.957c0 1.991 1.655 3.609 3.65 3.609h27.593c1.995 0 3.647-1.619 3.647-3.609v-5.956c0-.552-.136-1.068-.36-1.537h6.396c2.14 0 3.729 1.494 3.729 3.256v10.79c0 1.391 2.083 1.391 2.083 0v-10.79c0-3-2.667-5.339-5.812-5.339h-14.895c-1.511-3.527-4.745-6.017-8.583-6.021z",
    fillRule: "evenodd",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m36.396 12.825c1.208 0 2.192.994 2.192 2.286 0 1.296-.984 2.287-2.192 2.287-1.209 0-2.193-.991-2.193-2.287 0-1.292.984-2.286 2.193-2.286zm0-2.085c-2.365 0-4.276 1.986-4.276 4.371 0 2.386 1.911 4.369 4.276 4.369 2.364 0 4.271-1.983 4.271-4.369 0-2.385-1.907-4.371-4.271-4.371z",
    fillRule: "evenodd",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.948 35.152c-.579 0-1.043.47-1.043 1.042 0 .573.464 1.041 1.043 1.041h20.27c.572 0 1.042-.468 1.042-1.041 0-.572-.469-1.042-1.042-1.042z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.844 43.688c-1.319.125-1.224 2.078.104 2.073h16.041c.599.042 1.104-.437 1.104-1.036 0-.604-.505-1.079-1.104-1.037h-16.041c-.038-.005-.073-.005-.104 0z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.844 52.22c-1.319.124-1.224 2.083.104 2.072h14.525c.598.043 1.109-.432 1.109-1.036 0-.598-.511-1.079-1.109-1.036h-14.525c-.038 0-.073 0-.104 0z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.948 60.746c-1.391 0-1.391 2.084 0 2.084h16.041c1.385 0 1.385-2.084 0-2.084z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.844 69.277c-1.387.072-1.286 2.15.104 2.083h20.27c1.385 0 1.385-2.083 0-2.083h-20.27c-.038 0-.073 0-.104 0z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.921 53.13c-.058-.531-.511-.932-1.047-.926h-1.26c-1.391 0-1.391 2.084 0 2.084h1.26c.626.009 1.12-.537 1.047-1.158z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.124 53.13c-.056-.531-.509-.932-1.046-.926h-1.265c-1.385 0-1.385 2.084 0 2.084h1.265c.625.009 1.119-.537 1.046-1.158z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.572 42.86c-.421-.333-1.021-.296-1.395.089l-.891.891c-.412.406-.412 1.066-.005 1.474.411.412 1.066.407 1.473 0l.896-.891c.448-.438.413-1.172-.078-1.563z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.328 61.1c-.417-.333-1.021-.292-1.391.089l-.896.896c-.407.407-.407 1.068 0 1.475.407.405 1.068.405 1.473-.005l.891-.891c.453-.438.417-1.173-.077-1.564z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.738 63.464c.333-.416.292-1.02-.088-1.391l-.896-.896c-.407-.405-1.063-.405-1.468 0-.412.407-.407 1.068 0 1.475l.891.891c.438.453 1.171.415 1.561-.079z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.494 45.226c.333-.417.296-1.021-.089-1.396l-.891-.891c-.405-.407-1.066-.407-1.473 0-.407.405-.407 1.068 0 1.473l.896.891c.438.448 1.172.412 1.557-.077z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingHours);
export default __webpack_public_path__ + "static/media/working_hours.0d42f2a85871e20e81bfc1439f90cb89.svg";
export { ForwardRef as ReactComponent };